import { ExecuteMutation } from '../../../utils/Api';

export const updateOrganizationCustom = (inputData) => {
  return ExecuteMutation('updateOrganizationCustom', inputData);
};

